import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';
// @ts-expect-error not migrated to TS
import { getUserLanguage } from 'self-service-api/api/getUserLanguage';
export const getHighlightsForProductLine = productLine => {
  const {
    highlightedFreeProduct,
    highlightedProducts
  } = FullProductLineMap[productLine];
  return [...(highlightedFreeProduct ? [highlightedFreeProduct] : []), ...highlightedProducts];
};
export const getAllFreeProducts = () => {
  const productLines = Object.keys(FullProductLineMap);
  return productLines.map(productLine => {
    return FullProductLineMap[productLine].highlightedFreeProduct || null;
  });
};
export const getLangEligibleFeatureIds = ({
  featureIds,
  features
}) => {
  const languageToFilter = getUserLanguage();
  return featureIds.filter(featureId => {
    const {
      hideFromLang
    } = features[featureId];
    return hideFromLang ? hideFromLang !== languageToFilter : true;
  });
};
export const getLangEligibleFeatureIdsFromArray = ({
  features
}) => {
  const languageToFilter = getUserLanguage();
  return features.filter(feature => {
    const {
      hideFromLang
    } = feature;
    return hideFromLang ? hideFromLang !== languageToFilter : true;
  });
};
export const getProductLevelFromApiNameString = apiName => {
  const match = apiName.match(/-(\w*)$/);
  const level = (match[1] || '').toUpperCase();
  return level;
};
export const getProductLineFromApiNameString = apiName => {
  const match = apiName.match(/^(\w*)-/);
  const line = (match[1] || '').toUpperCase();
  return line;
};